import { ingestAPIObject } from "../utils/api";
export class UserRoleDTO {
    constructor(jsonData) {
        ingestAPIObject(this, jsonData);
        if (this.createdDate) {
            this.createdDate = new Date(this.createdDate);
        }
    }
}
export class CreateUserRoleDTO {
}
export class UpdateUserRoleDTO {
}
